// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bio-js": () => import("./../../../src/pages/bio.js" /* webpackChunkName: "component---src-pages-bio-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mission-partner-js": () => import("./../../../src/pages/mission-partner.js" /* webpackChunkName: "component---src-pages-mission-partner-js" */),
  "component---src-pages-mission-partner-two-js": () => import("./../../../src/pages/mission-partner-two.js" /* webpackChunkName: "component---src-pages-mission-partner-two-js" */)
}

